import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ChildOffersWrapper = styled.div`
    background: ${COLORS.BgSubstrate};
    padding: 16px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding-right: 20%;
    margin-bottom: 12px;

    & > div > div {
        padding: 0 !important;

        label {
            ${FONTS.MediumXS}

            input:checked ~ span {
                border-color: ${COLORS.ButtonPrimary} !important;
                background-color: transparent !important;

                &:after {
                    width: 12px !important;
                    height: 12px !important;
                    top: 3px !important;
                    left: 3px !important;
                    background-color: ${COLORS.ButtonPrimary} !important;
                }
            }

            span {
                height: 18px;
                width: 18px;
                border-width: 2px;
                border-color: ${COLORS.Outline_Dark}
            }
        }
    }
`;

export const PopupSectionTitle = styled.h5<{ inline?: boolean }>`
    ${FONTS.H5}
    ${({ inline }) => !inline && css`
        margin-bottom: 12px;
    `}
`;

export const BenefitsContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    width: 100%;

    & > div {
        &:not(:last-child) {
            margin-bottom: 4px;
        }
    }
`;

export const BodyCard = styled.div`
    padding: 24px 32px 32px 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    overflow: hidden;
    z-index: 1;
`;

export const ImageBackground = styled.div`
    background: #d6d6d6;
    width: 100%;
    height: auto;
    border-radius: ${BorderRadius.OuterBlockRadius}
        ${BorderRadius.OuterBlockRadius} 0px 0px;
    position: relative;
`;

export const HeaderImage = styled(LazyLoadImage)`
    width: 100%;
    object-fit: cover;
`;

export const BodyCardBadgesContainer = styled.div`
    width: 0;
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 4px;
    ${FONTS.XXS};
    text-transform: uppercase;
`;

export const ImageCardBadgesContainer = styled(BodyCardBadgesContainer)`
    position: absolute;
    bottom: 0;
    margin-bottom: 24px;
    margin-left: 32px;
`;

export const Title = styled.div`
    display: -webkit-box;
    color: ${COLORS.TextPrimary};
    ${FONTS.H3};
    text-transform: none;
    font-weight: bold;
    margin-bottom: 12px;
`;

export const Description = styled(Title)`
    color: ${COLORS.TextInfo};
    ${FONTS.S};
    font-weight: normal;
    margin-bottom: 6px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const FeaturesContainer = styled.div`
    margin-top: 24px;
    flex: 0 1 auto;
    display: flex;
    flex-wrap: wrap;
    row-gap: 32px;
    column-gap: 28px;
    width: 100%;
    height: 100%;
    z-index: 1;
`;

export const AccordionTheme = {
    background: COLORS.BgSubstrate,
    border: COLORS.transparent,
    borderWidth: 0,
    radius: BorderRadius.InnerBlockRadius,
    padding: '6px 24px',
    mobilePadding: '6px 24px',

    desktopFont: FONTS.MediumS,

    borderIcon: COLORS.BgSubstrate,
    borderIconIsOpen: COLORS.BgSubstrate,
    backgroundIcon: COLORS.BgSubstrate,
    backgroundIconIsOpen: COLORS.BgSubstrate,
    colorArrow: COLORS.Control,
    colorArrowIsOpen: COLORS.Control,
};

export const AccordionWrapper = styled.div`
    margin-top: 28px;
`;

export const TermsLink = styled.a`
    display: -webkit-box;
    ${FONTS.MediumS};
    text-transform: none;
    font-weight: normal;
    overflow-wrap: anywhere;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    color: ${COLORS.Link};
    max-height: 4.6em;
`;

export const FeatureRow = styled.div`
    display: flex;
    gap: 28px;
`;

export const FeatureContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
`;

export const FeatureIcon = styled.i`
    margin-right: 8px;
`;

export const FeatureLabel = styled(Description)`
    color: ${COLORS.TextPrimary};
    ${FONTS.H5};
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
`;

export const Price = styled(Title)`
    ${FONTS.H2};
    margin-bottom: 0;
    font-size: 24px;
    line-height: 28px;
`;

export const OldPrice = styled(Title)`
    margin-left: 8px;
    ${FONTS.M};
    margin-bottom: 0;
    color: ${COLORS.TextHint};
    text-decoration: line-through;
    line-height: 24px;
`;

export const AllPricesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const PricesContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const BottomContainer = styled.div<{ childLength: number }>`
    flex: 1;
    margin-top: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${({ childLength }) =>
        childLength > 1 ? 'space-between' : 'flex-end'};
    width: 100%;
    gap: 12px;
`;

export const Popup = styled(DefaultPopup)`
    ${wideBreakpoints.mobile} {
        top: 100px;
    }

    min-height: auto;
`;
